import { z } from "zod"

/** Mirrors API person-name rules (VAPT Finding 10). */
export const PERSON_NAME_MIN_LENGTH = 2
export const PERSON_NAME_MAX_LENGTH = 100

const PERSON_NAME_ALLOW_PATTERN =
  /^[\p{L}\p{M}]+(?:[ '\u2019\-][\p{L}\p{M}]+)*\.?$/u

const PERSON_NAME_REJECT_PATTERN = /https?:|www\.|:\/\/|[<>]/i

export const PERSON_NAME_INVALID_MESSAGE =
  "Name may only contain letters, spaces, hyphens, apostrophes or a trailing period"

export function isValidPersonName(value: string): boolean {
  const name = value.trim()
  if (
    name.length < PERSON_NAME_MIN_LENGTH ||
    name.length > PERSON_NAME_MAX_LENGTH
  ) {
    return false
  }
  if (PERSON_NAME_REJECT_PATTERN.test(name)) {
    return false
  }
  return PERSON_NAME_ALLOW_PATTERN.test(name)
}

/**
 * Zod schema for user display names (register, admin create/edit).
 * Matches API `@IsPersonName` allow-list + URL reject rules.
 */
export const personNameSchema = z
  .string()
  .min(PERSON_NAME_MIN_LENGTH, "Full name must be at least 2 characters")
  .max(PERSON_NAME_MAX_LENGTH, "Full name must be at most 100 characters")
  .refine((v) => isValidPersonName(v), {
    message: PERSON_NAME_INVALID_MESSAGE,
  })
  .transform((v) => v.trim())
